<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >上岗申请</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入数字员工编号、数字员工名称、业务人员"
                                    clearable
                                    style="width: 110px"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="虚拟机" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    style="width: 80px"
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.allStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="发布阶段" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.pubstatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 70px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试发布"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="生产发布"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="部署平台" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.realPlatform"
                                    placeholder="全部"
                                    :options="formInput.planPlatform"
                                    clearable
                                    style="width: 80px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="总部" field="hqCode">
                            <template #default="{ data }">
                                <vxe-select
                                    transfer
                                    v-model="data.hqCode"
                                    :options="formInput.hqOptions"
                                    placeholder="全部"
                                    style="width: 90px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <div class="form-buttons">
                                    <vxe-button
                                        status="primary"
                                        @click="findData"
                                        @keyup.enter="findData"
                                    >
                                        查询
                                    </vxe-button>

                                    <vxe-button @click="clear">重置</vxe-button>

                                    <vxe-button
                                        status="success"
                                        @click="addPublish"
                                    >
                                        新增
                                    </vxe-button>

                                    <vxe-button @click="exportDataEvent">
                                        导出
                                    </vxe-button>
                                </div>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    `
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                    v-if="
                                        isShowEditRow ||
                                        row.CreateManEmail === this.getUserEmail
                                    "
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="操作"
                            width="180"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <!-- 添加业务人员 -->
                                <vxe-button
                                    v-if="
                                        (isShowEditRow ||
                                            row.CreateManEmail ===
                                                this.getUserEmail) &&
                                        (row.realPlatform == 'PT001' ||
                                            row.realPlatform == 'PT002')
                                    "
                                    type="text"
                                    class="publish-action publish-action--add"
                                    @click="addManRowEvent(row)"
                                    title="添加业务人员"
                                >加用户</vxe-button>

                                <!-- 变更上岗信息下拉 -->
                                <vxe-pulldown
                                    v-if="
                                        (isShowEditRow ||
                                            row.CreateManEmail ===
                                                this.getUserEmail) &&
                                        row.Status == '5' &&
                                        row.PubStateValue == '2'
                                    "
                                    transfer
                                >
                                    <template #default="{ $pulldown }">
                                        <vxe-button
                                            type="text"
                                            class="publish-action publish-action--change"
                                            title="变更上岗信息"
                                            @click="$pulldown.showPanel()"
                                        >变更</vxe-button>
                                    </template>

                                    <template #dropdown="{ $pulldown }">
                                        <div class="change-menu">
                                            <div
                                                class="change-menu-item"
                                                @click="
                                                    $pulldown.hidePanel();
                                                    changeFrequencyEvent(row);
                                                "
                                            >
                                                执行频次变更
                                            </div>

                                            <div
                                                class="change-menu-item"
                                                @click="
                                                    $pulldown.hidePanel();
                                                    changeTypeEvent(row);
                                                "
                                            >
                                                数字员工类型变更
                                            </div>
                                        </div>
                                    </template>
                                </vxe-pulldown>
                                <!-- 退役申请 -->
                                <vxe-button
                                    type="text"
                                    class="publish-action publish-action--retire"
                                    v-if="
                                        (isShowEditRow ||
                                            row.CreateManEmail ===
                                                this.getUserEmail) &&
                                        (row.Status == '5' ||
                                            row.Status == '6' ||
                                            row.Status == '7') &&
                                        row.PubStateValue == '2'
                                    "
                                    @click="retireRowEvent(row)"
                                    title="退役申请"
                                >退役</vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="修改"
                            width="50"
                            :visible="isShowEditRow"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-pencil-square"
                                    @click="editAdminEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="编辑" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editRowEvent(row)"
                                    v-if="
                                        isShowEditRow ||
                                        row.CreateManEmail === this.getUserEmail
                                    "
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="更新包"
                            align="center"
                            width="70"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="
                                        (isShowEditRow ||
                                            row.CreateManEmail ===
                                                this.getUserEmail) &&
                                        (row.realPlatform == 'PT001' ||
                                            row.realPlatform == 'PT002' ||
                                            row.realPlatform == 'PT005')
                                    "
                                    type="text"
                                    icon="fa fa-upload"
                                    @click="updatePackage(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            align="center"
                            title="状态"
                            width="120"
                            resizable
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.AuditStatus === '已审核',
                                        error: row.AuditStatus.includes('驳回'),
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.AuditStatus }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="PubState"
                            title="发布阶段"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessID"
                            title="开发编号"
                            width="110"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="数字员工名称"
                            width="220"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empTypeName"
                            title="数字员工类型"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="introduction"
                            title="数字员工简介"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="empNo"
                            title="数字员工编号"
                            width="140"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="realPlatformName"
                            title="部署平台"
                            width="100"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="deployType"
                            title="运行方式"
                            width="100"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="业务人员"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="winMan"
                            title="总部窗口"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="techName"
                            title="辅导老师"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="sceneName"
                            title="场景组担当"
                            width="140"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="申请时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="AuditTime"
                            title="审批时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManSingleTime"
                            title="Before-人工每次耗时(分钟)"
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="ManFrequency"
                            title="Before-人工每月次数"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="RobotSingleTime"
                            title="After-每次耗时(分钟)"
                            width="200"
                            sorable
                        ></vxe-column>
                        <vxe-column
                            field="RobotMonthRun"
                            title="After-每月次数"
                            width="140"
                        ></vxe-column>
                        <vxe-column
                            field="DevelopTime"
                            title="开发时间(小时)"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="SingleSaveTime"
                            title="单次节省-时间(分钟)"
                            show-overflow
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="CreateMan"
                            title="创建人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreateManEmail"
                            title="创建人邮箱"
                            width="180"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserID"
                            title="UserID"
                            show-overflow
                            width="100"
                            :visible="false"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            200,
                            { label: '全部数据', value: 10000 },
                        ]"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>

            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form :data="userTablePager">
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectUser"
                                        >确定</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #title>
                                    <span>已选(</span
                                    ><span style="color: red">双击选择</span
                                    ><span>)</span>
                                </template>
                                <template #default>
                                    <div v-if="formInput.userSelType == 1">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.DevelopIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-else-if="formInput.userSelType == 2">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="clearUser(item.ID)"
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                    <div v-else-if="formInput.userSelType == 3">
                                        <template
                                            v-for="(
                                                item, index
                                            ) in formInputRetire.formData
                                                .leaderIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-if="formInput.userSelType == 4">
                                        <template
                                            v-for="(
                                                item, index
                                            ) in formInputAddMan.formData
                                                .UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="
                                                    clearUserAddMan(item.ID)
                                                "
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Uid"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                show-overflow
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="Id"
                                title="Id"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="userListPageChange"
                            size="small"
                        ></vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="更新包"
                v-model="packageForm.iShow"
                width="950"
                show-zoom
                resize
            >
                <template #default>
                    <div>
                        <vxe-form :data="packageForm">
                            <vxe-form-item
                                title="发布包"
                                field="packageName"
                                span="16"
                                :item-render="{}"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="packageForm.packageName"
                                        placeholder="请选择发布包"
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="2" :item-render="{}">
                                <template #default="">
                                    <vxe-button
                                        :disabled="packageForm.isDisable"
                                        @click="insertUpdatePackageEvent"
                                    >
                                        浏览
                                    </vxe-button>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="6" :item-render="{}">
                                <span style="color: red; margin-left: 10px"
                                    >一天最多上传{{
                                        packageForm.uploadTimes
                                    }}次</span
                                >
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="packageForm.dtPackage"
                            ref="xTableUser"
                            height="300"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="url"
                                title="文件名"
                                width="200"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="versioncode"
                                title="版本号"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="applytime"
                                title="上传时间"
                                width="140"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="IsUse"
                                title="是否在用"
                                width="100"
                                sortable
                                resizable
                            >
                                <template #default="{ row }">
                                    <span :style="{ color: row.IsUse === '是' ? 'red' : undefined }">{{ row.IsUse }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                align="center"
                                title="使用此版本"
                                width="100"
                            >
                                <template #default="{ row }">
                                    <vxe-button
                                        type="text"
                                        @click="choosePackage(row)"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-column>
                            <vxe-column align="center" title="下载" width="80">
                                <template #default="{ row }">
                                    <vxe-button
                                        type="text"
                                        style="color: blue"
                                        @click="downloadPackage(row)"
                                        >下载</vxe-button
                                    >
                                </template>
                            </vxe-column>
                            <vxe-column
                                align="left"
                                title="备注"
                                show-overflow
                                resizable
                            >
                                <template #default="{ row }">
                                    <vxe-button
                                        type="text"
                                        icon="fa fa-edit"
                                        @click="editRowRemark(row)"
                                    ></vxe-button>
                                    <span>{{ row.Description }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="Id"
                                title="Id"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="
                                updatePackagePager.currentPage
                            "
                            v-model:page-size="updatePackagePager.pageSize"
                            :total="updatePackagePager.totalResult"
                            @page-change="updatePackageListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <!-- 退役申请-->
            <vxe-modal
                v-model="formInputRetire.isShow"
                @close="closeWinEvent"
                :title="formInputRetire.title"
                width="840"
                height="490"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInputRetire.formData"
                        :rules="formInputRetire.formRules"
                        title-align="right"
                        ref="rFormRetire"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="开发编号"
                            field="ProcessID"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputRetire.formData.ProcessID"
                                    placeholder="请输入开发编号"
                                    :disabled="formInputRetire.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工名称"
                            field="ProcessName"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputRetire.formData.ProcessName
                                    "
                                    readonly
                                    placeholder="请输入数字员工名称"
                                    :disabled="formInputRetire.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="开发人员"
                            field="DevelopUser"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="
                                        formInputRetire.formData.DevelopUser
                                    "
                                    placeholder="请输入开发人员"
                                    :disabled="formInputRetire.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="科长"
                            field="leader"
                            span="10"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputRetire.formData.leader"
                                    readonly
                                    placeholder="请选择科长"
                                    :disabled="formInputRetire.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectUser(3)"
                                    :disabled="formInputRetire.allInputDisable"
                                    >选择
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总部窗口"
                            field="winMan"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInputRetire.formData.winMan"
                                    readonly
                                    :disabled="formInputRetire.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="12">
                            <template #default>
                                <div>(总部窗口审核，邮件通知科长)</div>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="退役原因"
                            field="retireReason"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="
                                        formInputRetire.formData.retireReason
                                    "
                                    placeholder="请输入退役原因"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="注意："
                            field=""
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <span style="color: red"
                                    >退役流程发起后，流程将无法使用，退役不是流程停用而是彻底下架退出，请谨慎操作。</span
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            align="center"
                            span="24"
                            v-if="!formInputRetire.saveButDisable"
                        >
                            <template #default>
                                <vxe-button
                                    @click="closeRetire()"
                                    icon="fa fa-close"
                                    status="danger"
                                    >退出
                                </vxe-button>
                                <vxe-button
                                    :loading="submitting"
                                    @click="submitRetire"
                                    icon="fa fa-check"
                                    status="primary"
                                    >提交
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!-- 添加业务人员申请-->
            <vxe-modal
                v-model="formInputAddMan.isShow"
                @close="closeWinEvent"
                :title="formInputAddMan.title"
                width="840"
                height="460"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <a-tabs v-model:activeKey="activeKey">
                        <a-tab-pane key="1" tab="新增申请">
                            <vxe-form
                                :data="formInputAddMan.formData"
                                :rules="formInputAddMan.formRules"
                                title-align="right"
                                ref="rFormAddMan"
                                title-width="60"
                            >
                                <vxe-form-item
                                    title="开发编号"
                                    field="processID"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputAddMan.formData
                                                    .processID
                                            "
                                            placeholder="请输入开发编号"
                                            :disabled="
                                                formInputAddMan.allInputDisable
                                            "
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工名称"
                                    field="processName"
                                    span="12"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputAddMan.formData
                                                    .processName
                                            "
                                            readonly
                                            placeholder="请输入数字员工名称"
                                            :disabled="
                                                formInputAddMan.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="开发人员"
                                    field="developer"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputAddMan.formData
                                                    .developer
                                            "
                                            placeholder="请输入开发人员"
                                            :disabled="
                                                formInputAddMan.allInputDisable
                                            "
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="原业务人员"
                                    field="oldUserName"
                                    span="12"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputAddMan.formData
                                                    .oldUserName
                                            "
                                            readonly
                                            placeholder=""
                                            :disabled="
                                                formInputAddMan.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="新业务人员"
                                    field="UserNameEmail"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputAddMan.formData
                                                    .UserNameEmail
                                            "
                                            readonly
                                            placeholder="请选择新业务人员"
                                            :disabled="
                                                formInputAddMan.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default>
                                        <vxe-button
                                            @click="selectUser(4)"
                                            :disabled="
                                                formInputAddMan.allInputDisable
                                            "
                                            >选择
                                        </vxe-button>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="申请原因"
                                    field="reqReason"
                                    span="24"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-textarea
                                            rows="4"
                                            v-model="
                                                formInputAddMan.formData
                                                    .reqReason
                                            "
                                            placeholder="请输入申请原因"
                                            maxlength="1000"
                                            show-word-count
                                        ></vxe-textarea>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    align="center"
                                    span="24"
                                    v-if="!formInputAddMan.saveButDisable"
                                >
                                    <template #default>
                                        <vxe-button
                                            @click="closeAddMan()"
                                            icon="fa fa-close"
                                            status="danger"
                                            >退出
                                        </vxe-button>
                                        <vxe-button
                                            :loading="submitting"
                                            @click="submitAddMan"
                                            icon="fa fa-check"
                                            status="primary"
                                            >提交
                                        </vxe-button>
                                    </template>
                                </vxe-form-item>
                            </vxe-form>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="申请历史">
                            <div style="overflow: hidden; height: 100%">
                                <vxe-table
                                    stripe
                                    class="mytable-scrollbar"
                                    :data="tableDataHis"
                                    :height="300"
                                    show-overflow
                                    :row-config="{
                                        height: 36,
                                        isHover: true,
                                        isCurrent: true,
                                    }"
                                    ref="xTableHis"
                                >
                                    <vxe-column
                                        type="seq"
                                        field="Id"
                                        title="序号"
                                        width="50"
                                    ></vxe-column>
                                    <vxe-column
                                        field="statusName"
                                        title="状态"
                                        width="100"
                                        show-overflow
                                        resizable
                                        sortable
                                    >
                                        <template #default="{ row }">
                                            <vxe-button
                                                v-bind:class="{
                                                    active:
                                                        row.statusName ===
                                                        '已审核',
                                                    error:
                                                        row.statusName ===
                                                        '已驳回',
                                                }"
                                                type="text"
                                                @click="showAuditList(row)"
                                                >{{ row.statusName }}
                                            </vxe-button>
                                        </template>
                                    </vxe-column>
                                    <vxe-column
                                        field="processName"
                                        title="数字员工名称"
                                        width="180"
                                        show-overflow
                                        resizable
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="processID"
                                        title="开发编号"
                                        width="120"
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="developer"
                                        title="开发人员"
                                        width="100"
                                        show-overflow
                                        resizable
                                    ></vxe-column>
                                    <vxe-column
                                        field="creationTime"
                                        title="创建日期"
                                        width="120"
                                        sortable
                                        :formatter="formatTime"
                                    ></vxe-column>
                                    <vxe-column
                                        field="oldUserName"
                                        title="原业务人员"
                                        width="120"
                                        show-overflow
                                        resizable
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="UserNameEmail"
                                        title="新业务人员"
                                        width="120"
                                        show-overflow
                                        resizable
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="reqReason"
                                        title="申请原因"
                                        width="120"
                                        resizable
                                        show-overflow
                                    ></vxe-column>
                                </vxe-table>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </template>
            </vxe-modal>
            <!-- 备注-->
            <vxe-modal
                v-model="formInputPackage.isShow"
                @close="closeWinEventPackage"
                :title="formInputPackage.title"
                width="600"
                height="250"
                show-zoom
                resize
                remember
                show-footer
            >
                <template #default>
                    <vxe-form
                        :data="formInputPackage.formData"
                        :rules="formInputPackage.formRules"
                        title-align="right"
                        ref="rFormPackage"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="备注"
                            field="Description"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-textarea
                                    v-model="
                                        formInputPackage.formData.Description
                                    "
                                    :rows="4"
                                    placeholder="请输入备注"
                                />
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
                <template #footer>
                    <div style="text-align: center; width: 100%">
                        <vxe-button
                            :loading="submitting"
                            @click="saveDescription"
                            icon="fa fa-save"
                            status="success"
                            >保存
                        </vxe-button>
                        <vxe-button
                            @click="closeWinEventPackage"
                            icon="fa fa-check"
                            status="primary"
                            >关闭
                        </vxe-button>
                    </div>
                </template>
            </vxe-modal>

            <addNewPublish
                ref="addNewPublishRef"
                @flashPubList="findData"
            ></addNewPublish>
            <EmpTypeChangeApply ref="empTypeChangeRef" @flashPubList="findData">
            </EmpTypeChangeApply>

            <FrequencyChangeApply
                ref="frequencyChangeRef"
                @flashPubList="findData"
            >
            </FrequencyChangeApply>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref, nextTick } from "vue";
import { VXETable } from "vxe-table";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";
import addNewPublish from "../dashboardNew/addNewPublish.vue";
import EmpTypeChangeApply from "./EmpTypeChangeApply.vue";
import FrequencyChangeApply from "./FrequencyChangeApply.vue";

export default {
    name: "PublishApply",
    components: {
        MyAuditLine,
        addNewPublish,
        EmpTypeChangeApply,
        FrequencyChangeApply,
    },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const reqTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const updatePackagePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            allStatus: [],
            allReqPlatform: [],
            formData: {
                selectMac: "",
                status: "",
                pubstatus: "",
                searchKey: "",
                dept: "",
                realPlatform: "",
                reqPlatform: "",
                hqCode: "",
            },
        });

        const packageForm = reactive({
            dtPackage: [],
            realPlatform: "", //部署平台
            iShow: false, //显示更新包
            packageFile: {}, //更新包附件
            packageName: "",
            uploadTimes: 0, //可以上传次数
            selPublishId: "", //更新的ID
            isDisable: false,
        });

        const formInput = reactive({
            title: "新增上岗申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            processIDReadonly: true,
            userSelType: 2, //1 开发人员 2 业务人员
            allTechs: [], //技术组担当
            allScenes: [], //场景组担当
            planPlatform: [], //部署平台
            digitalTypes: [], //员工类型
            hqOptions: [], //所有总部
            sceneUID: "",
        });
        const formInputRetire = reactive({
            title: "退役申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            userSelType: 3, // 科长
            formData: {
                Id: "",
                AuditStatus: "0",
                ProcessID: "",
                ProcessName: "",
                DevelopUser: "",
                DevelopUserUID: "",
                leader: "",
                leaderUID: "",
                retireReason: "",
                leaderIDName: [],
                winMan: "",
            },
            formRules: {
                ProcessID: [{ required: false, message: "开发编号不能为空" }],
                ProcessName: [
                    { required: true, message: "数字员工名称不能为空" },
                ],
                DevelopUser: [{ required: true, message: "开发人员不能为空" }],
                leader: [{ required: true, message: "科长不能为空" }],
                retireReason: [{ required: true, message: "退役原因不能为空" }],
                winMan: [{ required: true, message: "总部窗口不能为空" }],
            },
        });

        const formInputPackage = reactive({
            title: "编辑备注",
            isShow: false,
            formData: {
                Id: "",
                Description: "",
            },
            formRules: {},
        });

        const formInputAddMan = reactive({
            title: "添加业务人员",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            userSelType: 4, // 添加业务人员
            formData: {
                Id: "",
                pubId: "",
                reqType: "1", //申请类型
                status: "0",
                processID: "",
                processName: "",
                developer: "",
                oldUserName: "",
                oldUserID: "",
                UserName: "",
                UserId: "",
                UserNameEmail: "",
                UserIDName: [],
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "申请原因不能为空" }],
                UserNameEmail: [
                    { required: true, message: "新业务人员不能为空" },
                ],
            },
        });
        const activeKey = ref("1");
        const addNewPublishRef = ref(null);
        const empTypeChangeRef = ref(null);
        const frequencyChangeRef = ref(null);

        return {
            tableData: null,
            tableDataHis: null,
            tablePager,
            userTablePager,
            updatePackagePager,
            toolbar,
            pageHeight,
            formInput,
            formInputRetire,
            formInputAddMan,
            dtUser: null,
            iShowSelectUser: ref(false),
            onePackageFile: {}, //上传的附件
            isShowPackageLink: false,
            onePDDFile: {}, //上传的附件
            isShowPDDLink: false,
            onePhotoFile: {}, //上传的附件
            isShowPhotoLink: false,
            dtAudit: [],
            isShowAuditList: false,
            packageForm,
            isShowEditRow: false, //管理员编辑列
            reqTablePager,
            dtReqs: [], //需求列表
            tableHeight: 0,
            submitting: false,
            activeKey,
            isViewFooter: true,
            otherPlatformLabel: "其他部署平台",
            isDifyDE: false,
            addNewPublishRef,
            formInputPackage,
            frequencyChangeRef,
            empTypeChangeRef,
        };
    },
    methods: {
        formatTime({ cellValue }) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.selectMac,
                    this.toolbar.formData.status,
                    this.toolbar.formData.pubstatus,
                    "",
                    this.toolbar.formData.realPlatform,
                    this.toolbar.formData.hqCode,
                ],
            };
            this.$api.newPublishManageAPI
                .getPublishList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        userListPageChange() {
            this.findUserData();
        },
        reqListPageChange() {
            this.findReqsData();
        },
        closeWinEventPackage() {
            this.formInputPackage.isShow = false;
            this.findPackageData();
        },
        bindAllStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["28"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.allStatus = [];
                    for (const item of res.data.Data) {
                        this.toolbar.allStatus.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addAuditRecord(status, type) {
            let auditBuId = "";
            let auditOpinion = "";
            switch (type) {
                case "1":
                    auditBuId = this.formInput.formData.Id;
                    auditOpinion = "";
                    break;
                case "2":
                    auditBuId = this.formInputRetire.formData.Id;
                    auditOpinion = "数字员工退役发起";
                    break;
                case "3":
                    auditBuId = this.formInputAddMan.formData.Id;
                    auditOpinion = "添加业务使用人发起";
                    break;
            }
            //写审核日志
            const params = {
                auditBuId: auditBuId,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: auditOpinion,
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPC() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [""], //RPA
            };
            this.$api.systemManageAPI
                .getMachineListByType(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.RobotName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
            this.toolbar.formData.pubstatus = "";
            this.toolbar.formData.realPlatform = "";
            this.toolbar.formData.hqCode = "";
        },
        changeFrequencyEvent(row) {
            this.$refs.frequencyChangeRef.init(row);
        },
        changeTypeEvent(row) {
            this.$refs.empTypeChangeRef.init(row);
        },
        //删除
        async removeRowEvent(row) {
            if (
                row.AuditStatus.includes("审核中") ||
                ["已审核", "已上岗", "退役中", "已退役"].includes(
                    row.AuditStatus
                )
            ) {
                await VXETable.modal.message({
                    content: "审批中，已审批和已退役不能删除，请先驳回",
                    status: "error",
                });
                return;
            }

            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                this.$api.newPublishManageAPI
                    .delPublish(
                        Qs.stringify({ publishId: row.Id, editType: "1" })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //退役
        async retireRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.newPublishManageAPI
                .getPublishOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    this.formInputRetire.formData.Id = res.data.Data.Id;
                    this.formInputRetire.formData.ProcessID =
                        res.data.Data.ProcessID;
                    this.formInputRetire.formData.ProcessName =
                        res.data.Data.ProcessName;
                    this.formInputRetire.formData.DevelopUser =
                        res.data.Data.DevelopUser;
                    this.formInputRetire.formData.DevelopUserUID =
                        res.data.Data.DevelopUserUID;
                    this.formInputRetire.formData.leader = res.data.Data.leader;
                    this.formInputRetire.formData.leaderUID =
                        res.data.Data.leaderUID;
                    this.formInputRetire.formData.retireReason =
                        res.data.Data.retireReason;
                    this.formInputRetire.formData.winMan =
                        res.data.Data.curWinMan;

                    if (
                        row.AuditStatus === "已审核" &&
                        row.PubState === "生产发布"
                    ) {
                        this.formInputRetire.allInputDisable = false;
                        this.formInputRetire.saveButDisable = false;
                    } else {
                        this.formInputRetire.allInputDisable = true;
                        this.formInputRetire.saveButDisable = true;
                    }
                    this.formInputRetire.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //添加业务人员
        async addManRowEvent(row) {
            this.formInputAddMan.formData.Id = this.$utils.guid();
            this.formInputAddMan.formData.pubId = row.Id;
            this.formInputAddMan.formData.processID = row.ProcessID;
            this.formInputAddMan.formData.processName = row.ProcessName;
            this.formInputAddMan.formData.developer = row.DevelopUser;
            this.formInputAddMan.formData.oldUserName = row.UserNameEmail;
            this.formInputAddMan.formData.oldUserID = row.UserID;
            this.formInputAddMan.formData.UserNameEmail = "";
            this.formInputAddMan.formData.UserName = "";
            this.formInputAddMan.formData.UserId = "";
            this.formInputAddMan.formData.UserIDName = [];
            this.formInputAddMan.formData.reqReason = "";
            this.formInputAddMan.formData.creator = this.$store.state.Id;

            if (row.AuditStatus === "已审批" || row.AuditStatus === "已审核") {
                this.formInputAddMan.allInputDisable = false;
                this.formInputAddMan.saveButDisable = false;
            } else {
                this.formInputAddMan.allInputDisable = true;
                this.formInputAddMan.saveButDisable = true;
            }
            this.findAddManHis(row.Id);
            this.formInputAddMan.isShow = true;
        },
        saveDescription() {
            this.$api.newPublishManageAPI
                .updatePackageDescription(
                    Qs.stringify({
                        Id: this.formInputPackage.formData.Id,
                        Description: this.formInputPackage.formData.Description,
                    })
                )
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "更新成功",
                        status: "success",
                    });
                    this.closeWinEventPackage();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //管理员修改
        editAdminEvent(row) {
            this.$refs.addNewPublishRef.editRowEvent(row, 2);
        },
        //编辑数据
        editRowEvent(row) {
            this.$refs.addNewPublishRef.editRowEvent(row, 1);
        },
        editRowRemark(row) {
            this.formInputPackage.formData.Description = row.Description;
            this.formInputPackage.formData.Id = row.Id;
            this.formInputPackage.isShow = true;
        },
        //更新发布包
        updatePackage(row) {
            this.updatePackagePager.currentPage = 1;
            this.updatePackagePager.pageSize = 10;
            this.packageForm.selPublishId = row.Id;
            this.packageForm.packageName = "";
            this.packageForm.packageFile = {};
            this.packageForm.realPlatform = row.realPlatform;
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.updatePackagePager.currentPage,
                pageSize: this.updatePackagePager.pageSize,
                searchKey: [this.packageForm.selPublishId],
            };

            this.$api.newPublishManageAPI
                .getPackageList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.dtPackage = res.data.Data.dataTable;
                    this.updatePackagePager.currentPage =
                        res.data.Data.currentPage;
                    this.updatePackagePager.pageSize = res.data.Data.pageSize;
                    this.updatePackagePager.totalResult =
                        res.data.Data.totalResult;
                    this.packageForm.iShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });

            this.$api.newPublishManageAPI
                .getPackageUpdateCount(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.uploadTimes = res.data.Data.totalCount;
                    if (res.data.Data.remainCount <= 0) {
                        this.packageForm.isDisable = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //使用版本
        choosePackage(row) {
            const params = {
                uid: this.$store.state.userID,
                email: "",
                currentPage: "",
                pageSize: "",
                searchKey: [
                    this.packageForm.selPublishId,
                    row.Id,
                    row.versioncode,
                ],
            };

            this.$api.newPublishManageAPI
                .updatePackageVersion(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    VXETable.modal.message({
                        content: "更新成功",
                        status: "success",
                    });
                    this.findPackageData();
                })
                .catch((error) => {
                    console.log(error);
                });

            this.$api.newPublishManageAPI
                .getPackageUpdateCount(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.uploadTimes = res.data.Data.totalCount;
                    if (res.data.Data.remainCount <= 0) {
                        this.packageForm.isDisable = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        downloadPackage(row) {
            this.$api.fileManageAPI
                .downloadPublishFile(
                    Qs.stringify({
                        publishId: row.publish_id,
                        type: "7",
                        Id: row.Id,
                    }),
                    {
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    const contentType = res.headers["content-type"] || "";

                    // 后端返回 JSON，说明是错误信息
                    if (contentType.includes("application/json")) {
                        const reader = new FileReader();

                        reader.onload = () => {
                            try {
                                const result = JSON.parse(reader.result);

                                VXETable.modal.alert({
                                    content:
                                        result.Message ||
                                        result.message ||
                                        "下载失败",
                                    status: "error",
                                });
                            } catch (e) {
                                VXETable.modal.alert({
                                    content: "下载失败",
                                    status: "error",
                                });
                            }
                        };

                        reader.readAsText(res.data);
                        return;
                    }

                    let fileName = "下载文件";

                    const disposition =
                        res.headers["content-disposition"] ||
                        res.headers["Content-Disposition"];

                    if (disposition) {
                        const utf8Match = disposition.match(
                            /filename\*=UTF-8''([^;]+)/i
                        );
                        const normalMatch =
                            disposition.match(/filename="?([^"]+)"?/i);

                        if (utf8Match && utf8Match[1]) {
                            fileName = decodeURIComponent(utf8Match[1]);
                        } else if (normalMatch && normalMatch[1]) {
                            fileName = decodeURIComponent(normalMatch[1]);
                        }
                    }

                    const blob = new Blob([res.data], {
                        type: contentType || "application/octet-stream",
                    });

                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.download = fileName;
                    link.style.display = "none";

                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.log(error);

                    VXETable.modal.alert({
                        content: "文件下载失败",
                        status: "error",
                    });
                });
        },
        closeWinEvent() {
            this.findData();
        },
        //新增
        addPublish() {
            this.$refs.addNewPublishRef.addPublish();
        },
        selectUser(type) {
            this.formInput.userSelType = type;
            this.findUserData();
            this.iShowSelectUser = true;
        },
        confirmSelectUser() {
            this.iShowSelectUser = false;
        },
        //删除用户
        clearUser(userid) {
            let idx = -1;
            this.formInput.formData.UserIDName.forEach(function (
                item,
                index,
                arr
            ) {
                if (item.ID == userid) {
                    idx = index;
                }
            });
            let tmpId = [],
                tmpname = [];
            tmpId = this.formInput.formData.UserId.toString().split(";");
            tmpname =
                this.formInput.formData.UserNameEmail.toString().split(";");
            tmpId.splice(idx, 1);
            tmpname.splice(idx, 1);
            this.formInput.formData.UserId = tmpId.join(";");
            this.formInput.formData.UserNameEmail = tmpname.join(";");
            let count = 0;
            if (this.formInput.formData.UserId.toString() != "") {
                count =
                    this.formInput.formData.UserId.toString().split(";").length;
            }
            this.formInput.formData.UserIDName = [];
            //debugger
            for (let i = 0; i < count; i++) {
                this.formInput.formData.UserIDName.push({
                    Name: this.formInput.formData.UserNameEmail.toString().split(
                        ";"
                    )[i],
                    ID: this.formInput.formData.UserId.toString().split(";")[i],
                });
            }
        },
        //删除新增业务人员
        clearUserAddMan(userid) {
            let idx = -1;
            this.formInputAddMan.formData.UserIDName.forEach(function (
                item,
                index,
                arr
            ) {
                if (item.ID == userid) {
                    idx = index;
                }
            });
            let tmpId = [],
                tmpname = [];
            tmpId = this.formInputAddMan.formData.UserId.toString().split(";");
            tmpname =
                this.formInputAddMan.formData.UserNameEmail.toString().split(
                    ";"
                );
            tmpId.splice(idx, 1);
            tmpname.splice(idx, 1);
            this.formInputAddMan.formData.UserId = tmpId.join(";");
            this.formInputAddMan.formData.UserNameEmail = tmpname.join(";");
            let count = 0;
            if (this.formInputAddMan.formData.UserId.toString() != "") {
                count =
                    this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    ).length;
            }
            this.formInputAddMan.formData.UserIDName = [];
            //debugger
            for (let i = 0; i < count; i++) {
                this.formInputAddMan.formData.UserIDName.push({
                    Name: this.formInputAddMan.formData.UserNameEmail.toString().split(
                        ";"
                    )[i],
                    ID: this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    )[i],
                });
            }
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            //选开发人员
            if (this.formInput.userSelType === 1) {
                this.formInput.formData.DevelopUser =
                    record.UserName + "(" + record.UserMail + ")";
                this.formInput.formData.DevelopUserUID = record.Id;
                this.formInput.formData.DevelopIDName = [];
                this.formInput.formData.DevelopIDName.push({
                    Name: this.formInput.formData.DevelopUser,
                    ID: this.formInput.formData.DevelopUserUID,
                });

                //选业务人员
            } else if (this.formInput.userSelType === 2) {
                //判断是否已选择过
                if (this.formInput.formData.UserId.toString() != "") {
                    for (let item of this.formInput.formData.UserId.toString().split(
                        ";"
                    )) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }

                if (
                    this.formInput.formData.UserNameEmail == null ||
                    this.formInput.formData.UserNameEmail == ""
                ) {
                    this.formInput.formData.UserNameEmail =
                        record.UserName + "(" + record.UserMail + ")";
                } else {
                    this.formInput.formData.UserNameEmail +=
                        ";" + record.UserName + "(" + record.UserMail + ")";
                }
                if (
                    this.formInput.formData.UserId == null ||
                    this.formInput.formData.UserId == ""
                ) {
                    this.formInput.formData.UserId = record.Id;
                } else {
                    this.formInput.formData.UserId += ";" + record.Id;
                }
                let count =
                    this.formInput.formData.UserId.toString().split(";").length;
                this.formInput.formData.UserIDName = [];
                for (let i = 0; i < count; i++) {
                    this.formInput.formData.UserIDName.push({
                        Name: this.formInput.formData.UserNameEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInput.formData.UserId.toString().split(
                            ";"
                        )[i],
                    });
                }
                //选择退役审批科长
            } else if (this.formInput.userSelType == 3) {
                this.formInputRetire.formData.leader =
                    record.UserName + "(" + record.UserMail + ")";
                this.formInputRetire.formData.leaderUID = record.Id;
                this.formInputRetire.formData.leaderIDName = [];
                this.formInputRetire.formData.leaderIDName.push({
                    Name: this.formInputRetire.formData.leader,
                    ID: this.formInputRetire.formData.leaderUID,
                });
            } else {
                //判断是否已选择过
                if (this.formInputAddMan.formData.UserId.toString() != "") {
                    for (let item of this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    )) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }
                if (this.formInputAddMan.formData.oldUserID != "") {
                    for (let item of this.formInputAddMan.formData.oldUserID
                        .toString()
                        .split(";")) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员在原业务人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }
                if (
                    this.formInputAddMan.formData.UserNameEmail == null ||
                    this.formInputAddMan.formData.UserNameEmail == ""
                ) {
                    this.formInputAddMan.formData.UserNameEmail =
                        record.UserName + "(" + record.UserMail + ")";
                } else {
                    this.formInputAddMan.formData.UserNameEmail +=
                        ";" + record.UserName + "(" + record.UserMail + ")";
                }
                if (
                    this.formInputAddMan.formData.UserId == null ||
                    this.formInputAddMan.formData.UserId == ""
                ) {
                    this.formInputAddMan.formData.UserId = record.Id;
                } else {
                    this.formInputAddMan.formData.UserId += ";" + record.Id;
                }

                let count =
                    this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    ).length;
                this.formInputAddMan.formData.UserIDName = [];
                for (let i = 0; i < count; i++) {
                    this.formInputAddMan.formData.UserIDName.push({
                        Name: this.formInputAddMan.formData.UserNameEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInputAddMan.formData.UserId.toString().split(
                            ";"
                        )[i],
                    });
                }
            }
        },
        async closeRetire() {
            this.formInputRetire.isShow = false;
        },
        async closeAddMan() {
            this.formInputAddMan.isShow = false;
        },
        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updatePackageListPageChange() {
            this.findPackageData();
        },
        findPackageData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.updatePackagePager.currentPage,
                pageSize: this.updatePackagePager.pageSize,
                searchKey: [this.packageForm.selPublishId],
            };
            this.$api.newPublishManageAPI
                .getPackageList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.dtPackage = res.data.Data.dataTable;
                    this.updatePackagePager.currentPage =
                        res.data.Data.currentPage;
                    this.updatePackagePager.pageSize = res.data.Data.pageSize;
                    this.updatePackagePager.totalResult =
                        res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        exportDataEvent() {
            const $table = this.$refs.xTable1;
            $table.exportData({ type: "csv" });
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        //上传发布包
        async insertUpdatePackageEvent() {
            this.packageForm.packageName = "";
            this.packageForm.packageFile = {};
            const { files } = await VXETable.readFile(false);

            Array.from(files).map((file) => {
                this.packageForm.packageName = file.name;
                this.packageForm.packageFile = file;
            });

            let suffix = this.packageForm.packageName
                .toString()
                .substring(
                    this.packageForm.packageName.toString().lastIndexOf(".") + 1
                );

            if (
                this.packageForm.realPlatform === "UiPath" &&
                suffix !== "nupkg"
            ) {
                VXETable.modal.alert({
                    content: "发布包类型不正确，应为nupkg",
                    status: "error",
                });
                return;
            }
            if (
                this.packageForm.realPlatform === "派神易" &&
                suffix !== "zip"
            ) {
                VXETable.modal.alert({
                    content: "发布包类型不正确,应为zip",
                    status: "error",
                });
                return;
            }
            if (
                this.packageForm.realPlatform === "Python" &&
                suffix !== "rar"
            ) {
                VXETable.modal.alert({
                    content: "发布包类型不正确,应为rar",
                    status: "error",
                });
                return;
            }

            const params = new FormData();

            params.append("publishId", this.packageForm.selPublishId);
            params.append("file", this.packageForm.packageFile);
            params.append("fileName", this.packageForm.packageName);
            params.append("realPlatform", this.packageForm.realPlatform);

            this.$api.newPublishManageAPI
                .updatePublishPackage(params)
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "上传成功，请30秒后再运行数字员工",
                        status: "success",
                    });
                    this.addPackageQueue(this.packageForm.selPublishId);
                    this.findPackageData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        downloadFile(type) {
            this.$api.fileManageAPI
                .downloadPublishFile(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: type,
                    })
                )
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.alert({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    window.open(res.data.Data, "_blank").location;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //提交退役申请
        async submitRetire() {
            const $rForm = this.$refs.rFormRetire;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

            if (type === "confirm") {
                const data = this.formInputRetire.formData;

                this.submitting = true;
                this.$api.newPublishManageAPI
                    .submitPublishRetire(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "2"); //写审核日志
                        this.formInputRetire.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        //提交申请使用人
        async submitAddMan() {
            const $rForm = this.$refs.rFormAddMan;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

            if (type === "confirm") {
                this.formInputAddMan.formData.UserName =
                    this.formInputAddMan.formData.UserId;
                const data = this.formInputAddMan.formData;

                this.submitting = true;
                this.$api.newPublishManageAPI
                    .submitPublishAddMan(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "3"); //写审核日志
                        this.formInputAddMan.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        updateSingleSaveTime() {
            this.formInput.formData.SingleSaveTime =
                this.formInput.formData.ManSingleTime -
                this.formInput.formData.RobotSingleTime;
        },
        findAddManHis(pubId) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [pubId],
            };
            this.$api.newPublishManageAPI
                .getProcessAddManList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableDataHis = res.data.Data.dataTable;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addPackageQueue(publishid) {
            //插入包更新队列
            const params = {
                Id: "",
                Priority: 1,
                PubId: publishid,
                HandleType: 1, //0首次 1 更新包
                Status: 0, // 待处理
                StartTime: "",
                EndTime: "",
                Creator: this.$store.state.userID,
                CreationTime: "",
                ErrorMsg: "",
                ExtraMsg: "",
            };
            this.$api.newPublishManageAPI
                .addPackageQueue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindTechMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getTechMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allTechs = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allTechs.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindSceneMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getSceneMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allScenes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allScenes.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDeployPlatformList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.planPlatform = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.planPlatform.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindDigitalType() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDigitalMemberTypeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.digitalTypes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.digitalTypes.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHQ() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        console.log(res.data.Message);
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.hqOptions = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.hqOptions.push({
                            value: item.hqCode,
                            label: item.hqName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHeadquarterScene() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: ["", this.$store.state.jobZb],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterSceneOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    if (
                        Array.isArray(res.data.Data.dataTable) &&
                        res.data.Data.dataTable.length > 0
                    ) {
                        this.formInput.sceneUID =
                            res.data.Data.dataTable[0].uid;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.bindPC();
        this.bindHQ();
        this.bindAllStatus();
        this.bindTechMember();
        this.bindSceneMember();
        this.bindHeadquarterScene();
        this.bindPlatform();
        this.bindDigitalType();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    created() {
        this.isShowEditRow = this.$store.state.isAdmin === "1";
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserUID() {
            return this.$store.state.userID;
        },
        getUserId() {
            return this.$store.state.Id;
        },
        getTechName() {
            const selected = this.formInput.allTechs.find(
                (t) => t.value === this.formInput.formData.techUID
            );
            return selected ? selected.label : "";
        },
        getSceneName() {
            const selected = this.formInput.allScenes.find(
                (t) => t.value === this.formInput.formData.sceneUID
            );
            return selected ? selected.label : "";
        },
    },
};
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}

.publish-action {
    font-weight: 600;
}

.publish-action--add {
    color: #1677ff;
}

.publish-action--add:hover {
    color: #0958d9;
}

.publish-action--change {
    color: #d46b08;
}

.publish-action--change:hover {
    color: #ad4e00;
}

.publish-action--retire {
    color: #722ed1;
}

.publish-action--retire:hover {
    color: #531dab;
}

.change-menu {
    min-width: 150px;
    padding: 6px 0;
    background: #fff;
    border: 1px solid #e8eaec;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.change-menu-item {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 13px;
    white-space: nowrap;
}

.change-menu-item:hover {
    background: #f5f7fa;
    color: #409eff;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
<style lang="css" scoped>
.form-buttons {
    display: flex;
    align-items: center;
    gap: 4px;
}

/* 清除 vxe-button 默认的按钮间距 */
.form-buttons :deep(.vxe-button + .vxe-button) {
    margin-left: 0;
}
</style>
